import * as React from 'react';
import {status} from "../constants";
import {abbreviationName} from '../../../../common/util';
import UserImage from '../../../../components/UserImage/index';

export default class BulkActionTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.renderTemplate = this.renderTemplate.bind(this);
    }

    renderTemplate(data, type) {
        switch (type) {
            case "BulkOwnerChange":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        Workload of <a href={data.OldTargetUserProfile} title={data.OldTargetFullName}>{data.OldTargetFullName}</a> has been transferred to <a href={data.TargetUserProfile} title={data.TargetUserFullName}>{data.TargetUserFullName}.</a>
                        </span>
                    </React.Fragment>
                );
            case "BulkViewActivityOwnerChange":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>
                            {
                                (data.ActivityCount == 1) ?
                                    <>{data.ActivityCount} activity</>
                                    :
                                    <>{data.ActivityCount} activities</>
                            } </a>{(data.ActivityCount == 1) ? " has " : " have "}been transferred to <a style={{cursor:"pointer"}} userid={data.TargetUserId} className="tool_tip" title={data.TargetUserFullNameFull}>{data.TargetUserFullNameFull}</a>
                        </span>
                    </React.Fragment>
                );
            case "BulkViewActivityNewOwner":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ?
                            <>{data.ActivityCount} activity</> : <>{data.ActivityCount} activities</>}</a>{(data.ActivityCount == 1) ? " has ":" have "}been transferred to you as the new Activity Owner
                        </span>
                    </React.Fragment>
                );

            case "BulkViewChangeActivityDueDate":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} activity</> : <> {data.ActivityCount} activities</>}</a>{(data.ActivityCount == 1) ? " has ":" have "}been edited
                        </span>
                    </React.Fragment>
                );
            case "BulkWorkkardOwnerChange":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} workkard</> : <> {data.ActivityCount} workkards</>}</a>{(data.ActivityCount == 1) ? " has " : " have "}been transferred to 
                            <a style={{cursor:"pointer"}} userid={data.TargetUserId} className="tool_tip" title={data.TargetUserFullNameFull}>{data.TargetUserFullNameFull}</a>
                        </span>
                    </React.Fragment>
                );

            case "BulkWorkkardOwnerChangeToYou":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} workkard</> : <> {data.ActivityCount} workkards</>}</a>{(data.ActivityCount == 1) ?" has ":" have "}been transferred to you as the new Workkard Owner
                        </span>
                    </React.Fragment>
                );

            case "BulkViewCloseActivity":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}> {(data.ActivityCount == 1) ? <>{data.ActivityCount} activity</> : <> {data.ActivityCount} activities</>}</a>{(data.ActivityCount == 1) ? " has " : " have "} been closed/closed midterm
                        </span>
                    </React.Fragment>
                );
            case "BulkAssigneeChange":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            Workload of <a href={data.OldTargetUserProfile} title={data.OldTargetFullName}>{data.OldTargetFullName}</a> has been transferred to <a href={data.TargetUserProfile} title={data.TargetUserFullName}>{data.TargetUserFullName}.</a>
                        </span>
                    </React.Fragment>
                );

            case "bulkactivityownerchange":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        Workload of <a href={data.OldTargetUserProfile} title={data.OldTargetFullName}>{data.OldTargetFullName}</a> has been transferred to <a href={data.TargetUserProfile} title={data.TargetUserFullName}>{data.TargetUserFullName}.</a>
                        </span>
                    </React.Fragment>
                );

            case "BulkAcceptActivity":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            {(data.ActivityCount == 1) ? 
                            <><a href={data.ActivityDetailUrl}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a> has</>
                            :
                           <><a href={data.RedirectUrl}>{data.ActivityCount}</a> activities</>}{(data.ActivityCount == 1) ?" has ":" have "}been Accepted
                        </span>
                    </React.Fragment>
                );

            case "BulkRejectActivity":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        {(data.ActivityCount == 1) ?
                            <span className="welcome_txt"><a href={data.ActivityDetailUrl}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}>{data.WorkkardNo}</a> has been Rejected</span>
                        :
                            <span className="welcome_txt"><a href={data.RedirectUrl}>{data.ActivityCount} Activities</a> have been Rejected</span>
                        }                                
                    </React.Fragment>
                );

            case "BulkDiaryEdited":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} diary</> : <>{data.ActivityCount} diaries</>}</a>{(data.ActivityCount == 1) ? " has ":" have "} been edited
                        </span>
                    </React.Fragment>
                );
            case "BulkDiaryCancelled":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>
                            {
                                (data.ActivityCount == 1) ?
                                    <>{data.ActivityCount} diary</>
                                    :
                                    <>{data.ActivityCount} diaries</>
                            }</a>{(data.ActivityCount == 1) ? " has ": " have "}been cancelled
                        </span>
                    </React.Fragment>
                );
            case "BulkViewActivityReassignedToUser":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.RedirectUrl} title={data.ActivityCount}> {(data.ActivityCount == 1) ?
                            <>{data.ActivityCount} activity</> : <>{data.ActivityCount} activities</>}</a>{(data.ActivityCount == 1) ? " has " : " have "}been reassigned to <a href={data.TargetUserProfile} title={data.TargetUserFullNameFull}>{data.TargetUserFullName}</a>
                        </span>
                    </React.Fragment>
                );

            case "BulkViewActivityReassignedToOrg":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} activity</> : <> {data.ActivityCount} activities</>}</a>{(data.ActivityCount == 1) ? " has " : " have "}been reassigned to <a href="javascript:void(0);" className="org-tooltip" orgId={data.B2BOrgId} onClick={(e)=>this.props.extraData.onProfileClick(e,data.B2BOrgId,'org')}>{data.B2BOrganisationName}</a>
                        </span>
                    </React.Fragment>
                );

            case "BulkViewActivityReassignedToYou":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} activity</> : <> {data.ActivityCount} activities</>} </a>{(data.ActivityCount == 1) ? " has ":" have "}been reassigned to you
                        </span>
                    </React.Fragment>
                );
            case "BulkViewActivityReassignedClosed":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} activity</> : <> {data.ActivityCount} activities</>} </a>{(data.ActivityCount == 1) ? " has " : " have "}been reassigned and closed
                        </span>
                    </React.Fragment>
                );
            case "BulkViewActivityAssignedToOrg":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} activity</> : <> {data.ActivityCount} activities</>} </a>{(data.ActivityCount == 1) ? " has " : " have "}been assigned to <a href="javascript:void(0);" className="org-tooltip" orgId={data.B2BOrgId} onClick={(e)=>this.props.extraData.onProfileClick(e,data.B2BOrgId,'org')}>{data.B2BOrganisationName}</a>
                        </span>
                    </React.Fragment>
                );

            case "BulkViewActivityCompleted":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.ActivityCount == 1) ?
                            <><a href={data.ActivityDetailUrl}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.workkardnoFull}> {data.WorkkardNo}</a> has been Completed</>
                            : (data.ActivityCount > 1 ?
                                <><a href={data.RedirectUrl}>{data.ActivityCount} Activities</a> have been Completed</> : null
                            )}
                        </span>
                    </React.Fragment>
                );

            case "BulkViewCompleteDiary":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} diary</> : <> {data.ActivityCount} diaries</>} </a>{(data.ActivityCount == 1) ? " has " : " have "}been completed
                        </span>
                    </React.Fragment>
                );
            case "BulkDiaryAssigned":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href={data.RedirectUrl} title={data.ActivityCount}>{(data.ActivityCount == 1) ? <>{data.ActivityCount} Diary</> : <> {data.ActivityCount} Diaries</>} </a>{(data.ActivityCount == 1) ? " has " : " have "}been transferred to you as new Diary Owner
                        </span>
                    </React.Fragment>
                );

            case "BulkDiaryReAssigned":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            {(data.ActivityCount == 1) ?
                                <><a href={data.RedirectUrl} title={data.ActivityCount}> {data.ActivityCount} Diary</a> has been transferred to <a href={data.TargetUserProfile}>{data.TargetUserFullName}</a></>
                                :
                                <><a href={data.RedirectUrl} title={data.ActivityCount}> {data.ActivityCount} Diaries</a> have been transferred to <a href={data.TargetUserProfile}>{data.TargetUserFullName}</a></>
                            }
                        </span>
                    </React.Fragment>
                );
        }
    }

    render() {
        const {extraData}=this.props;
        return (
            <div className={extraData.displayMarkReadIcon ? (`card ${extraData.IsGroupByEnabled  && !extraData.showGroupedNotificationDetail ? 'cardGroup' :'cardPlain'} ${this.props.data.Status == status.read ? 'cardGroupRead' : ''}`):''} onClick={()=>{(extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail) ? this.props.handleCardClick(this.props.data) :false}}>
                {
                    extraData.displayMarkReadIcon && 
                    <React.Fragment>
                        {
                            <span className="posRight quickTooltip-bottom" data-quicktooltip={this.props.data.Status == status.read ? "mark as unread": "mark as read"} 
                            onClick={(e)=>{
                                e.stopPropagation();
                                        if(this.props.data.Status == status.read)
                                            extraData.handleMarkRead(this.props.data,status.unRead)
                                        else
                                            extraData.handleMarkRead(this.props.data,status.read)
                                        }}>
                                <em className={`read ${this.props.data.Status == status.read ? "unread":""}`}></em>
                            </span>
                        }
                        {extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail?<div className="rwoFlex alignMiddle wkNumber">
                            <label className="badges wkSymbol mr__1">{this.props.data.WorkkardId?'W':'0'}</label> {this.props.data.WorkkardNo?this.props.data.WorkkardNo:'Others'}
                            {
                                extraData.IsGroupByEnabled && extraData.GroupNotificationCounter > 0 && <label className="newCard ml__1">{extraData.GroupNotificationCounter > 99 ? '99+' : extraData.GroupNotificationCounter} new{extraData.RecentWorkkardCountRecieved && <span className="newCardNotification"></span>}</label>
                            }
                        </div> : this.props.data.AllNotificationCount > 0 ? <div className="rwoFlex alignMiddle"><label className="newCard">new</label></div> : null} 
                    </React.Fragment>
                }
                <div className={extraData.displayProfilePic ? "rowFlex mt activity_desc":"rowFlex activity_desc"}>
                    {
                        extraData.displayProfilePic && 
                        <div className="badges badgesSmall mr">
                              <UserImage profileUrl={this.props.data.TriggeredByProfileImage} size="22" className="profilePic" profileName={this.props.data.TriggeredByFullName}/>
                        
                        </div>
                    }
                    <div className={extraData.displayProfilePic ?"":"notificationDate"}> 
                        {
                            extraData.displayTriggerByName && 
                            <>
                                <span className="userName flexGrow" onClick={(e)=>extraData.onProfileClick(e,this.props.data.TriggeredById,'user')}>{this.props.data.TriggeredByFullName}</span>
                                {extraData.showGroupedNotificationDetail && <label>{abbreviationName(this.props.data.TriggeredByOrganisationNameFull)}</label>}
                            </>
                        }                                
                        {this.renderTemplate(this.props.data, this.props.type)}
                        <label className={extraData.displayProfilePic ? "notification__time" : "notification__time gray"}>{extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </div>
                </div>
            </div>
        );
    }
}